<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="8.25" stroke="#1B294A" stroke-width="1.5"/>
    <path d="M12.8573 9.71833H9.00014L6.42871 5.43262" stroke="#1B294A" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconClock'
}
</script>
